// extracted by mini-css-extract-plugin
export var footer = "_nm-5";
export var fulfillmentInput = "_nm-0";
export var shipDateInput = "_nm-1";
export var shipmentModal = "_nm-2";
export var shipmentModalContent = "_nm-3";
export var tableContainer = "_nm-4";